/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filename: NonNullable<unknown> }} Filesdeleteconfirm2Inputs */

const en_filesdeleteconfirm2 = /** @type {(inputs: Filesdeleteconfirm2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.filename}"?`)
};

const pt_filesdeleteconfirm2 = /** @type {(inputs: Filesdeleteconfirm2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apagar "${i?.filename}"?`)
};

/**
* | output |
* | --- |
* | "Delete \"{filename}\"?" |
*
* @param {Filesdeleteconfirm2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesdeleteconfirm2 = /** @type {((inputs: Filesdeleteconfirm2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesdeleteconfirm2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesdeleteconfirm2(inputs)
	return pt_filesdeleteconfirm2(inputs)
});
export { filesdeleteconfirm2 as "filesDeleteConfirm" }